import * as Braze from '@braze/web-sdk'
import type { ContentCard } from '@braze/react-native-sdk'
import { mapContentCardsToRN } from './mapContentCardsToRN'

export default function getCachedContentCards(): Promise<ContentCard[]> {
  const contentCards = Braze.getCachedContentCards()
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  return Promise.resolve(contentCards?.cards.map((card) => mapContentCardsToRN(card)) || [])
}
